module.exports = __webpack_public_path__ + "ui-design.3yLkHugr.svg";